import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ModernCareerWebsite } from './components/ModernCareerWebsite';
import ActiveClientPage from './components/ActiveClientPage';
import PreCounselingForm from './components/PreCounsellingForm';
import AdminLayout from './admin/layout/AdminLayout';
import { AdminLogin, ProtectedRoute } from './admin/auth/AdminLogin';
import AdminDashboard from './admin/components/AdminDashboard';
import ClientProfile from './admin/components/ClientProfile';
import AdminLandingPage from './admin/layout/AdminLandingPage';
import SessionsPage from './admin/components/SessionsPage';
import { AuthProvider, useAuth } from './admin/auth/AuthContext';
import JamshedpurPage from './components/JamshedpurPage';
import RanchiPage from './components/RanchiPage';
import BlogList from './components/blog/BlogList';
import BlogPost from './components/blog/BlogPost';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<ModernCareerWebsite />} />
      
      {/* City-specific landing pages with unique content */}
      <Route path="/jamshedpur" element={<JamshedpurPage />} />
      <Route path="/ranchi" element={<RanchiPage />} />

      {/* Blog */}
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      
      <Route path="/active-client" element={<ActiveClientPage />} />
      <Route path="/enrollment" element={<PreCounselingForm />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      
      {/* Protected Admin Routes */}
      <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
        {/* Admin Landing Page - separate from layout */}
        <Route path="/admin" element={<AdminLandingPage />} />
        
        {/* Routes with AdminLayout (sidebar) */}
        <Route path="/admin/dashboard/*" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard/clients" replace />} />
          <Route path="clients" element={<AdminDashboard />} />
          <Route path="clients/:id" element={<ClientProfile />} />
          <Route path="documents" element={<AdminDashboard />} />
          <Route path="sessions" element={<SessionsPage />} />
          <Route path="reports" element={<AdminDashboard />} />
          <Route path="notes" element={<AdminDashboard />} />
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;